import * as React from "react";
import {
  ConstBreakPoint,
  ConstColor,
  ConstFontStyle,
} from "src/config/styles_const/styles_const";
import styled from "styled-components";
import HeadlineSmall from "../../atom/text/headline_small";
import ParagraphSup from "../../atom/text/paragraph_sup";

interface IProps {
  q?: string;
  a?: string;
}

const CampaignQa: React.FC<IProps> = (props) => {
  const { q, a } = props;

  return (
    <Wrapper>
      <CampaignQaWrapper>
        <CampaignQuestionWrapper>
          <CampaignQuestion>{q}</CampaignQuestion>
        </CampaignQuestionWrapper>
        <CampaignAnserWrapper>
          <CampaignAnser bold={true}>{a}</CampaignAnser>
        </CampaignAnserWrapper>
      </CampaignQaWrapper>
    </Wrapper>
  );
};

export default CampaignQa;

const Wrapper = styled.div`
  width: 100%;
`;

const CampaignQaWrapper = styled.div`
  margin-bottom: 35px;
`;

const CampaignQuestionWrapper = styled.div`
  background-color: ${ConstColor.circleProgressColorGreen};
  padding: 12px 24px;
`;

const CampaignAnserWrapper = styled.div`
  background-color: ${ConstColor.GreenGray};
  padding: 12px 24px;
`;

const CampaignQuestion = styled(HeadlineSmall)`
  color: ${ConstColor.White};
`;

const CampaignAnser = styled(ParagraphSup)`
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    white-space: pre-line;
    line-height: ${ConstFontStyle.ParagraphDefault.lineHeight};
    font-size: ${ConstFontStyle.MenuParagraphDefault.fontSize};
  }
`;
const CampaignMQuestionWrapper = styled.div`
  background-color: #f2b745;
  padding: 12px 24px;
`;

const CampaignMAnserWrapper = styled.div`
  background-color: #fffaef;
  padding: 12px 24px;
`;

export const CampaignMQa: React.FC<IProps> = (props) => {
  const { q, a } = props;

  return (
    <Wrapper>
      <CampaignQaWrapper>
        <CampaignMQuestionWrapper>
          <CampaignQuestion>{q}</CampaignQuestion>
        </CampaignMQuestionWrapper>
        <CampaignMAnserWrapper>
          <CampaignAnser bold={true}>{a}</CampaignAnser>
        </CampaignMAnserWrapper>
      </CampaignQaWrapper>
    </Wrapper>
  );
};

const CampaignSQuestionWrapper = styled.div`
  background-color: #4668e5;
  padding: 12px 24px;
`;

const CampaignSAnserWrapper = styled.div`
  background-color: #f5f7ff;
  padding: 12px 24px;
`;

export const CampaignSQa: React.FC<IProps> = (props) => {
  const { q, a } = props;

  return (
    <Wrapper>
      <CampaignQaWrapper>
        <CampaignSQuestionWrapper>
          <CampaignQuestion>{q}</CampaignQuestion>
        </CampaignSQuestionWrapper>
        <CampaignSAnserWrapper>
          <CampaignAnser bold={true}>{a}</CampaignAnser>
        </CampaignSAnserWrapper>
      </CampaignQaWrapper>
    </Wrapper>
  );
};

const CampaignIQuestionWrapper = styled.div`
  background-color: #e5b858;
  padding: 12px 24px;
`;

const CampaignIAnserWrapper = styled.div`
  background-color: #fffbf0;
  padding: 12px 24px;
`;

export const CampaignIQa: React.FC<IProps> = (props) => {
  const { q, a } = props;

  return (
    <Wrapper>
      <CampaignQaWrapper>
        <CampaignIQuestionWrapper>
          <CampaignQuestion>{q}</CampaignQuestion>
        </CampaignIQuestionWrapper>
        <CampaignIAnserWrapper>
          <CampaignAnser bold={true}>{a}</CampaignAnser>
        </CampaignIAnserWrapper>
      </CampaignQaWrapper>
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/presentation/common/molecular/campaign/campaign-qa.tsx